import { jsx, jsxs } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useSignal } from "@builder.io/qwik";
import SelectContextId from "./select-context.qwik.mjs";
import { HiddenSelectOption } from "./hidden-select-option.qwik.mjs";
import { VisuallyHidden } from "../../utils/visually-hidden.qwik.mjs";
const HHiddenNativeSelect = component$((props) => {
  const { label, autoComplete, ref, ...rest } = props;
  const context = useContext(SelectContextId);
  const nativeSelectRef = useSignal();
  return /* @__PURE__ */ jsx(VisuallyHidden, {
    children: /* @__PURE__ */ jsx("div", {
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsxs("label", {
        children: [
          label,
          /* @__PURE__ */ jsxs("select", {
            ref: (element) => {
              nativeSelectRef.value = element;
              ref?.(element);
            },
            onFocus$: () => {
              context.triggerRef.value?.focus();
              return;
            },
            multiple: context.multiple,
            tabIndex: -1,
            autocomplete: autoComplete,
            disabled: context.isDisabledSig.value ? true : void 0,
            required: context.required,
            name: context.name,
            // height is determined by its children
            style: {
              height: "1px"
            },
            ...rest,
            children: [
              /* @__PURE__ */ jsx("option", {}),
              Array.from(context.itemsMapSig.value.entries()).map(([index, item]) => /* @__PURE__ */ jsx(HiddenSelectOption, {
                value: item.value,
                displayValue: item.displayValue,
                nativeSelectRef,
                index
              }, item.value))
            ]
          })
        ]
      })
    })
  });
});
export {
  HHiddenNativeSelect
};
